export const room_numbering_strategy_options = [
  { value: "SCANNING_PHASE", label: "Scanning Phase" },
  { value: "INSTALLATION_PHASE", label: "Installation Phase" },
  { value: "SEQUENTIAL", label: "Sequential" },
  { value: "MAC_ADDRESS", label: "MAC Address" },
  { value: "SERIAL_NUMBER", label: "Serial Number" },
];
